<template>
    <div class="channelItem coolItem" :class="{'coolItemDark':isDark}">
        <div class="title">
            <div class="left">
                <p>
                    <img src="@/assets/img/datamodel/match/iconSmallCool.png" alt="图表">
                    {{data.info.name}}
                </p>
                <em v-if="data.is_buy == 1 && data.has_data == 1" @click="goto(data.analy.url)">查看详情分析 ></em>
                <span v-else>{{  data.info.tag }}</span>
            </div>
            <div class="right">{{data.info.buy_count}}人解锁</div>
        </div>
        <div class="con">
            <div v-if="data.is_buy == 0 && data.has_data == 1" class="noVipHaveData" @click="goto(data.info.url)">
                <img v-if="isDark" src="@/assets/img/datamodel/match/noDataCoolDark.png" alt=""/>
                <img v-else src="@/assets/img/datamodel/match/noDataCool.png" alt=""/>
            </div>
            <div v-if="data.has_data == 0" class="noData">
                <div class="txt">
                    {{ data.info.desc }}
                </div>
                <div class="btm">
                    <div class="top">
                       <p class="res"> <span>历史命中</span> {{ dealDate(data.schedule.match_time) }} {{ data.schedule.sclass_name }}</p>
                       <p class="btn" @click="goto(data.info.url)">查看更多比赛预测</p>
                    </div>
                    <div class="info">
                        <div class="bettel">
                            <div class="team">
                                <p>{{ data.schedule.home_team }}</p>
                                <span>{{ data.schedule.home_score }}</span>
                            </div>
                            <div class="team">
                                <p>{{ data.schedule.guest_team }}</p>
                                <span>{{ data.schedule.guest_score }}</span>
                            </div>
                        </div>
                        <div class="predict">
                            <p>{{data.schedule.hit_odds}}<em>%</em></p>
                            <span>命中冷门高赔</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data.is_buy == 1 && data.has_data == 1" class="haveData">
                <div class="explain">
                    {{ data.analy.msg }}
                </div>
                <div class="charts">
                    <div class="chartsBox">
                        <van-circle
                            v-model="currentRate"
                            :rate="currentRate"
                            :stroke-width="160"
                            :size="45/37.5 + 'rem'"
                            color="#FF5048"
                            :layer-color="isDark?'#2f2f2f':'#EEEEEE'"
                        >
                            <span class="circleTxt">{{ currentRate }}<em>%</em></span>
                        </van-circle>
                    </div>
                    <span>冷门指数</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isLogin, doLogin, isJHAppios, isJHApp } from "../../../utils/base"
export default {
    name: 'coolItem',
    props: ['data', 'isDark'],
    data () {
        return {
            currentRate: 80
        }
    },
    watch: {
        data: {
            handler () {
                if (this.data.analy) {
                    this.currentRate = this.data.analy.cold
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        gobuy () {
            if (!isLogin) {
                doLogin();
                return
            }
            // const url = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + this.data.info.data_type;
            let url = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + this.data.info.data_type;
            if (isJHAppios() || !isJHApp()) {
                url = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + this.data.info.data_type;
            } else {
                url = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + this.data.info.data_type;
            }
            this.$emit('gobuy', url)
        },
        goto (url) {
            this.$emit('goModel', url)
        },
        dealDate (str) {
            return str.substring(5, 10).replace('-', '/')
        }
    }
}
</script>

<style lang="less" scoped>
.coolItem{
    .noData{
        .predict{
            color: #FF5048;
            margin-top:6px;
            p{
                font-family: HelveticaNeue-CondensedBlack, HelveticaNeue;
                font-weight: bold;
                color: #FF5048;
                line-height: 24px;
                font-size: 20px;
                text-align: right;
                em{
                    font-size: 10px;
                }
            }
            span{
                font-size: 10px;
                line-height: 14px;
            }
        }
    }
    .haveData{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .explain{
            width: 228px;
            font-size: 12px;
            color: #333333;
            line-height: 18px;
            margin-top: 15px;
        }
        .charts{
            width: 45px;
            .chartsBox{
                width: 100%;
                .circleTxt{
                    font-size: 15px;
                    color: #FF5048;
                    font-weight: bold;
                    line-height: 18px;
                    width: 100%;
                    height: 41px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    em{
                        font-size: 10px;
                    }
                }
            }
            span{
                font-size: 10px;
                line-height: 14px;
                color: #333333;
                margin-top: 4px;
            }
        }
    }
}
.coolItemDark{
    .haveData{
        background-color: #232323 !important;
        .explain{
            color: #d3d3d3 !important;;
        }
        .charts{
            span{
                color: #d3d3d3 !important;;
            }
        }
    }
}
</style>
